const inicializarTabla =  async ({ idReferencia, elementos, callbackCheck = () => {}, callbackPaginacion = () => {} }) => { 
    $("#" + idReferencia).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
    $("#" + idReferencia).bootstrapTable({  data: elementos });      
    $("#" + idReferencia).bootstrapTable('load', elementos ); 
    $("#" + idReferencia).on('check.bs.table',(e, row) => {
        callbackCheck();
    });
    $("#" + idReferencia).on('uncheck.bs.table',(e, row) => {
        callbackCheck();
    });
    $("#" + idReferencia).on('check-all.bs.table',(e, rows) => {
        callbackCheck();
    });
    $("#" + idReferencia).on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
        callbackCheck();
    });
    $("#" + idReferencia).on('page-change.bs.table',(e, rowsAfter, rowsBefore) => {
        callbackPaginacion();
    });
    $("#" + idReferencia).on('sort.bs.table',(e, rowsAfter, rowsBefore) => {
        callbackPaginacion();
    });
}

const actualizarFilas = ({ idReferenciaTabla, filas, llaveElemento }) => { 
    filas.forEach(filaActualizada => { 
        $("#" + idReferenciaTabla).bootstrapTable('updateByUniqueId', {
            id: filaActualizada[llaveElemento],
            row: filaActualizada
        });
    });
}

const insertarFilas = ({ idReferenciaTabla, filas, index }) => {
    let ultimaFila = index;
    filas.forEach(filaActualizada => {
        $("#" + idReferenciaTabla).bootstrapTable('insertRow', {
            index: ultimaFila,
            row: filaActualizada
        });
        ultimaFila ++;
    });
}

const eliminarFilas = ({ idReferenciaTabla, filas, llaveElemento }) => {
    $("#" + idReferenciaTabla).bootstrapTable('remove', {
        field: llaveElemento,
        values: filas
    });
}

export { inicializarTabla, actualizarFilas, insertarFilas, eliminarFilas };


// WEBPACK FOOTER //
// ./src/components/Audiencias/Programacion/Funciones/Tablas.js